/**
 * @generated SignedSource<<24e1eb9d926c2b9bc554bb01af492e1c>>
 * @relayHash 544af8d0da165bb16dedbbacb75ed9b2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0a659953ec84ef9ca013496aeacaa4b09af66c7137f9bcbd5f589c08a54fd0b4

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ClassificationLevelSource = "CONTENT" | "ORGANIZATION" | "SPACE" | "%future added value";
export type useContentClassificationContentDataClassificationQuery$variables = {
  contentId: string;
  lowerCaseContentStatusArray?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type useContentClassificationContentDataClassificationQuery$data = {
  readonly singleContent: {
    readonly classificationLevelDetails: {
      readonly classificationLevel: {
        readonly color: string | null | undefined;
        readonly description: string | null | undefined;
        readonly guideline: string | null | undefined;
        readonly id: string;
        readonly name: string;
        readonly status: string;
      } | null | undefined;
      readonly featureEnabled: boolean;
      readonly source: ClassificationLevelSource | null | undefined;
    } | null | undefined;
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type useContentClassificationContentDataClassificationQuery = {
  response: useContentClassificationContentDataClassificationQuery$data;
  variables: useContentClassificationContentDataClassificationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "lowerCaseContentStatusArray"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "status",
        "variableName": "lowerCaseContentStatusArray"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "concreteType": "ClassificationLevelDetails",
        "kind": "LinkedField",
        "name": "classificationLevelDetails",
        "plural": false,
        "selections": [
          {
            "concreteType": "ContentDataClassificationLevel",
            "kind": "LinkedField",
            "name": "classificationLevel",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "name": "guideline"
              },
              {
                "kind": "ScalarField",
                "name": "description"
              },
              {
                "kind": "ScalarField",
                "name": "color"
              },
              {
                "kind": "ScalarField",
                "name": "name"
              },
              {
                "kind": "ScalarField",
                "name": "status"
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "featureEnabled"
          },
          {
            "kind": "ScalarField",
            "name": "source"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useContentClassificationContentDataClassificationQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useContentClassificationContentDataClassificationQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "544af8d0da165bb16dedbbacb75ed9b2",
    "id": "0a659953ec84ef9ca013496aeacaa4b09af66c7137f9bcbd5f589c08a54fd0b4",
    "metadata": {},
    "name": "useContentClassificationContentDataClassificationQuery",
    "operationKind": "query",
    "text": "query useContentClassificationContentDataClassificationQuery($contentId:ID!,$lowerCaseContentStatusArray:[String]){singleContent(id:$contentId,status:$lowerCaseContentStatusArray){id,classificationLevelDetails{classificationLevel{id,guideline,description,color,name,status},featureEnabled,source}}}"
  }
};
})();

(node as any).hash = "7a15b44c908903b669004d9b98a12802";

export default node;
